import { useCallback } from 'react'
import { useToast } from '@machobear/design-system'
import { useTranslation } from 'react-i18next'

export const useShowLandlordErrorToast = () => {
  const { t } = useTranslation()
  const showToast = useToast()

  const showLandlordErrorToast = useCallback(() => {
    showToast({
      message: `${t('r.auth.view.oops.title', 'Oops')}. ${t(
        'r.auth.view.landlord_denied_error_toast.text',
        `You're currently logged in with a landlord account and won't be able to send messages or apply to listings. If you already have a renter account, please log in to proceed. If you made this account in error, you can contact us at support@liv.rent.`
      )}`,
      tone: 'critical'
    })
  }, [showToast, t])

  return showLandlordErrorToast
}
